/**
 * 应用入口文件
 * 创建 Vue 3 应用实例，注册全局插件（Router、Ant Design Vue），挂载到 DOM。
 */
import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import Antd from "ant-design-vue";
import "ant-design-vue/dist/reset.css";
import { authStore } from "./store/auth";
import { get } from "./utils/request";

/**
 * 抑制 ResizeObserver loop 无害警告
 * ECharts 的 autoresize 功能可能触发 ResizeObserver loop limit exceeded 错误，
 * 该错误不影响功能，此处将其静默处理以避免控制台干扰。
 */
const _onerror = window.onerror;
window.onerror = function (msg, ...args) {
  if (typeof msg === "string" && msg.includes("ResizeObserver loop"))
    return true;
  return _onerror?.apply(this, [msg, ...args]);
};

/* 创建应用实例并挂载 */
const app = createApp(App);
app.use(router);
app.use(Antd);

/* 启动时恢复登录状态：如果 localStorage 有 token，调用 /v1/analytics/auth/me 验证并刷新用户信息 */
(async () => {
  if (authStore.state.token) {
    try {
      const json = await get("/v1/analytics/auth/me");
      if (json.code === 200 && json.data) {
        authStore.setUser(json.data);
      } else {
        authStore.clearAuth();
      }
    } catch {
      // 401 会被 request.js 自动处理（清除 token + 跳转登录页）
    }
  }
  app.mount("#app");
})();
